import React from 'react';
import Modal from './Modal';

const ConfirmModal = ({
  isOpen,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  onConfirm,
  onCancel,
  variant = 'danger',
  loading = false,
  error,
}) => {
  const confirmClasses =
    variant === 'danger'
      ? 'bg-orange-500 hover:bg-orange-600 text-white'
      : 'bg-gray-900 hover:bg-gray-800 text-white';

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      title={title}
      footer={
        <>
          <button
            type="button"
            onClick={onCancel}
            disabled={loading}
            className="border border-gray-300 bg-white rounded-lg px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-50"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            className={`rounded-lg px-4 py-2 text-sm disabled:opacity-50 ${confirmClasses}`}
          >
            {loading ? 'Please wait...' : confirmLabel}
          </button>
        </>
      }
    >
      <p className="text-sm text-gray-700">{message}</p>
      {error && <p className="text-sm text-red-600 mt-2">{error}</p>}
    </Modal>
  );
};

export default ConfirmModal;
